import { render, staticRenderFns } from "./AulaAvatar.vue?vue&type=template&id=29d4e1b4&scoped=true&"
import script from "./AulaAvatar.vue?vue&type=script&lang=js&"
export * from "./AulaAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AulaAvatar.vue?vue&type=style&index=0&id=29d4e1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4e1b4",
  null
  
)

export default component.exports